<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Hostel</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLinnk="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Hostel</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="ptb--100 ">
  <div class="container">
    <div class="row justify-content-center gx-4">
      <div class="col-md-12">
        <blockquote class="blockquote-div">
          <p>‘A home away from home’ in the truest sense!
          </p>
        </blockquote>
        <p>Our institute has a well-equipped hostel for students. For parents and students alike reaching out for a
          hostel can be an overwhelming experience. For the former it is sending their precious away from them. And, for
          the latter a new life where every step, each decision and every endeavor will act as a fuel to shape their
          future!</p>
        <p>We at GHRCACS ensure to engrave a culture to aid the students in adjusting, learning and living in a
          conducive environment. It’s our priority to provide them with social, mental and physical safety.
          Comprehensive care along with the latest in technology tools are made to work in the arena of safety measures.
          Alarm systems, warden, security staff are pursued for accomplishing the same</p>
        <p>Our hostel rooms are well furnished and have adequate lighting and ventilation facilities. We do comprehend
          the need to study in the late hours after college, thus, we have well equipped reading rooms to make this
          easier. We do have a round the clock power supply. After a diligent day at college the students need
          recreation facilities at their disposal. Hence, we have the recreation room to relax. And, for the
          sportsperson in you, plenty of sports facilities to hone your gaming skill or simply bask in the freshness!
        </p>
        <p>That one aspect that the students miss the most is the home cooked food. It is to take care of this criterion
          our mess provides with piping hot and fresh food for them. It is every bit delicious and maintains the hygiene
          standards. We do comprehend the need of medical assistance at any time of the day. Hence, we make sure to
          provide them with 24/7 ambulance facility and medical assistance if the need might arise.</p>
        <strong>The hostel provides with:-</strong>
        <ul>
          <li>Well-furnished and spacious rooms with cot, study table, chair and cupboard-&nbsp;aiding in
            making education as your sole aim</li>
          <li>Mess providing with hot and fresh food-&nbsp;to keep you energized</li>
          <li>Recreation room to relax-&nbsp;to replenish you after a day’s work</li>
          <li>24/7 ambulance availability-&nbsp;to tackle any health related issues</li>
          <li>Uninterrupted power supply-&nbsp;Eliminating any obstacles</li>
          <li>Sports facility -to ensure an all round development</li>
        </ul>
        <h4 class="yellow-color fw-bold my-2">And, before we wrap up:-</h4>
        <p>Your college life is the first experience you witness the world as an individual. Away from the heaven of
          your parents’ arms, you have immense to look forward to. They have trusted you with their money, their dreams
          and your life. Enjoy this beautiful phase of your life, but do remember to inculcate it with discipline,
          knowledge and skills. The studies you pursue here, the knowledge you gain in this tenure and the character you
          build will be the stepping stone for your future. Make every minute count!</p>
      </div>
    </div>
  </div>
</section>
